// extracted by mini-css-extract-plugin
export default {"row":"_2Tv7","data":"_1Qwx"};